import React, { useState } from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import Card from "../common/card";
import "./styles/works.css";
import { expandedCardBody } from "../common/expandedCard";

const Works = ({ onExpand }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
    onExpand();
  };

  const cardBody = {
  body: (
    <div className="works-body">
      <div className={isExpanded ? "work-expanded" : "work"}>
        <img src="./mg-logo.png" alt="facebook" className="work-image" />
        <div className="work-title">Mean Guppy</div>
        <div className="work-subtitle">Software Engineer</div>
        <div className="work-duration">2023 - Present</div>
      </div>
      <div className={isExpanded ? "work-expanded" : "work"}>
        <img src="./boca_code_logo.jpeg" alt="facebook" className="work-image" />
        <div className="work-title">Boca Code</div> {/* Changed title here */}
        <div className="work-subtitle">Software Engineer</div>
        <div className="work-duration">2022 - 2022</div>
      </div>

    </div>
  ),
};

  return (
    <div className="works">
      <Card
        icon={faBriefcase}
        title="Work"
        onClick={handleClick}
        body={isExpanded ? expandedCardBody : cardBody.body}
      />
    </div>
  );
};

export default Works;
